import { useState } from "react";
import { Row, Col, Input, Spinner } from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { investment } from "../investmentData"

const InvestForm = () => {
    const { state } = useLocation()
    const navigate = useNavigate()
    const [disable, setDisable] = useState(false)
    const [message, setMessage] = useState('')
    const [data, setData] = useState({
        name: "",
        occupation: "",
        phone: "",
        email: "",
        amount: "",
        tenor: "",
        packages: "",
        subject: "A new form submitted on your website"
    })

    const tracker = () => {
        // Trigger the Google Ads conversion event
        window.gtag('event', 'conversion', {
            'send_to': 'AW-16640852278/0PpSCKH7qcUZELaC_f49',
            'value': 1.0,
            'currency': 'USD'
        });
    }

    const handleDisable = () => {
        const { name, occupation, phone, email, amount, tenor, packages } = data
        if (name && occupation && phone && email && amount && tenor && packages) {
            setDisable(true)
            // tracker()
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent the default form submission
    
        const { name, occupation, phone, email, amount, tenor, packages, subject } = data;
    
        try {
            const response = await fetch("https://demo.bankvole.app/api/v1/investment/send/mail", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    name,
                    occupation,
                    phone,
                    email,
                    amount,
                    tenor,
                    packages,
                    subject,
                }),
            });
    
            if (response.ok) {
                // Successfully submitted
                navigate("/wealth-management?modal=true");
            } else {
                // Log the response status and body for debugging
                const errorData = await response.json();
                console.error("Failed to submit form:", response.status, errorData);
                setMessage("Could not submit your form. Please try again");
                setDisable(false);
            }
        } catch (error) {
            console.error("Error submitting form:", error.message);
            setMessage("A network error occurred. Please try again later.");
            setDisable(false);
        }
    };
    



    return (
        <div className="investment-form-container">
            <div className="top">
                <button onClick={() => navigate(-1)}><img src={`${process.env.PUBLIC_URL}/assets/icons/back.svg`} alt="back" /></button>
                <h1>Application Form</h1>
            </div>
            <div className="investment-form">
                <div className="mt-5">
                    <i>kindly fill in the following details</i>
                </div>
                <form method="POST" onSubmit={handleSubmit}>
                    {/* <input name="_redirect" type="hidden" id="name" value={window.location.origin+"/home/investment?modal=true"}/> */}
                    <Row>
                        <Col lg={6} md={6} sm={12} xs={12}>
                            <div>
                                <input placeholder="Full Name" name="Name" className="form-control rounded-0 shadow-none" required onChange={e => setData({ ...data, name: e.target.value })} />
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} xs={12}>
                            <div>
                                <input placeholder="Occupation" name="Occupation" type="text" className="form-control rounded-0 shadow-none" required onChange={e => setData({ ...data, occupation: e.target.value })} />
                            </div>
                            <div>
                                <input name="subject" type="hidden" value={'A new form submitted on your website'}  />
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} xs={12}>
                            <div>
                                <input placeholder="Phone No. (+234)" type="number" name="Number" className="form-control rounded-0 shadow-none" required onChange={e => setData({ ...data, phone: e.target.value })} />
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} xs={12}>
                            <div>
                                <input placeholder="Email Address" type="email" name="Email" className="form-control rounded-0 shadow-none" required onChange={e => setData({ ...data, email: e.target.value })} />
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} xs={12}>
                            <div>
                                <input placeholder="Amount" type="number" name="Invest Amount" className="form-control rounded-0 shadow-none" required onChange={e => setData({ ...data, amount: e.target.value })} />
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} xs={12}>
                            <div>
                                <Input className="form-control rounded-0 shadow-none" type="select" name="Tenor" id="exampleSelect" required onChange={e => setData({ ...data, tenor: e.target.value })}>
                                    <option selected disabled>Tenor</option>
                                    <option>3</option>
                                    <option>6</option>
                                    <option>9</option>
                                    <option>12</option>
                                    <option>24</option>
                                </Input>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} xs={12}>
                            <div>
                                <Input className="form-control rounded-0 shadow-none" type="select" name="Plan" id="exampleSelect" required onChange={e => setData({ ...data, packages: e.target.value })}>
                                    {investment.map(i => (<option key={i.id} selected={state && state.selectedPlan && i.id === state.selectedPlan}>{i.name}</option>))}
                                </Input>
                            </div>
                        </Col>
                    </Row>
                    <div className="text-center mt-2"><p d className="text text-danger">{message ?? ''}</p></div>
                    <div className="text-center mt-5"><button disabled={disable} className="btn btn-primary shadow-none" type="submit">{disable ? <Spinner /> : "Submit"}</button></div>

                </form>
            </div>

        </div>
    )
}

export default InvestForm
